/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Banner_Save_FailedInputs */



/**
* | output |
* | --- |
* | "Couldn't process that image. Please try another." |
*
* @param {Banner_Save_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const banner_save_failed = /** @type {((inputs?: Banner_Save_FailedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Banner_Save_FailedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Impossible de traiter cette image. Veuillez en essayer une autre.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se pudo procesar la imagen. Por favor, pruebe con otra.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Não foi possível processar a imagem. Por favor, tente outra.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile elaborare l'immagine. Riprovare con un'altra.")
	return /** @type {LocalizedString} */ ("Couldn't process that image. Please try another.")
});